import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import Button from '@material-ui/core/Button';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Dialog from '@afosto/app-components-react/Dialog';
import translations from './translations';

const ProductNotFoundDialog = ({ isOpen, onClose }) => (
  <Dialog open={isOpen} onClose={onClose}>
    <DialogTitle>
      <FormattedMessage {...translations.title} />
    </DialogTitle>
    <DialogContent>
      <FormattedMessage {...translations.message} />
    </DialogContent>
    <DialogActions>
      <Button color="primary" variant="contained" onClick={onClose}>
        <FormattedMessage {...translations.actions.close} />
      </Button>
    </DialogActions>
  </Dialog>
);

ProductNotFoundDialog.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
};

ProductNotFoundDialog.defaultProps = {
  isOpen: false,
  onClose: undefined,
};

export default ProductNotFoundDialog;
